export default __webpack_public_path__ + "static/media/compare.cc76eb06.svg";